import httpClient, { ApiResponse } from "./httpClient";

export const putUpdateStyles = async (styleText: string, backgroundStyles = false): Promise<ApiResponse<any>> =>
  httpClient.put(`/theme/update-styles`, {
    styleText,
    backgroundStyles,
  });
